// extracted by mini-css-extract-plugin
export default {"circle":"ButtonSpinner_circle__OcNW+"};